export default __webpack_public_path__ + "2022_03_01_16_57/media/black-cat.88fb7e4a.gif";